import DataCollectionComponent from '../../features/Targets';

const DataCollection = () => <DataCollectionComponent useAsDataCollectionModule={true} />;

export default DataCollection;
